import { render, staticRenderFns } from "./WarningRemind.vue?vue&type=template&id=1f2d7136&scoped=true&"
import script from "./WarningRemind.vue?vue&type=script&lang=js&"
export * from "./WarningRemind.vue?vue&type=script&lang=js&"
import style0 from "./WarningRemind.vue?vue&type=style&index=0&id=1f2d7136&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2d7136",
  null
  
)

export default component.exports